module.exports = __webpack_public_path__ + "img/logo-inverse-dev.7c560b29.svg";